export enum NotificationSize {
  MD = 'md',
  RG = 'rg',
  LG = 'lg'
}

export type NotificationShowInfo = 'icon' | 'number' | 'none';
